import BetaCodec from './beta';
import ByteArrayLengthCodec from './byteArrayLength';
import ByteArrayStopCodec from './byteArrayStop';
import ExternalCodec from './external';
import GammaCodec from './gamma';
import HuffmanIntCodec from './huffman';
import SubexpCodec from './subexp';
import { CramUnimplementedError } from '../../errors';
const codecClasses = {
    1: ExternalCodec,
    // 2: GolombCodec,
    3: HuffmanIntCodec,
    4: ByteArrayLengthCodec,
    5: ByteArrayStopCodec,
    6: BetaCodec,
    7: SubexpCodec,
    // 8: GolombRiceCodec,
    9: GammaCodec,
};
function getCodecClassWithId(id) {
    return codecClasses[id];
}
export function instantiateCodec(encodingData, dataType) {
    const CodecClass = getCodecClassWithId(dataType === 'ignore' ? 0 : encodingData.codecId);
    if (!CodecClass) {
        throw new CramUnimplementedError(`no codec implemented for codec ID ${encodingData.codecId}`);
    }
    return new CodecClass(encodingData.parameters, dataType, instantiateCodec);
}
//# sourceMappingURL=index.js.map